import { Alert } from "@mui/material";
import useCart from "../utils/useCart";


export default function Conflict(){

    const { cart } = useCart()

    return cart.error === 'conflict' &&
    
        <Alert severity="error">
            Vous êtes déjà inscrit à cette formation.
        </Alert>
}